import { createGlobalStyle } from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
  * {
      font-family: 'Inter', sans-serif;
      margin: 0;
      padding: 0;
      outline: 0;
      box-sizing: border-box;
    }

    *:focus {
      outline: 0;
    }

    html {
      overflow-x: hidden;
    }

    html, body, #root {
      min-height: 100vh;
    }

    body {
      -webkit-font-smoothing: antialiased;
      background-color: #212121;
      color: #FFFFFF;
    }

    html,
    body,
    input,
    button {
      font: 0.9vw 'Inter', sans-serif;
    }

    a {
      text-decoration: none;
      color: inherit;
    }

    h2 {
      font-size: 1.5rem;
    }

    ul {
      list-style: none;
    }

    button {
      cursor: pointer;
      background: none;
      border: 0;
    }
`;
